/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Length/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Length({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/New/TreatmentCard/Treatment/Content/Actions/Content/EditLength/Content/Length",
  isInvalid,
  onChange,
  onSubmit
  
}) {
let editLengthLengthInMonthsValueData = fromData.useDataValue({ viewPath,
context: 'edit_length',
path: 'length_in_months',
})
let editLengthLengthInMonthsIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_length',
path: 'length_in_months',
validate: fromValidate.numberPositive,
required: true,
})
let editLengthLengthInMonthsChangeData = fromData.useDataChange({ viewPath,
context: 'edit_length',
path: 'length_in_months',
})
let editLengthLengthInMonthsSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_length',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_length.length_in_months"
 validate="/Data/validate.js numberPositive"
 invalid={!editLengthLengthInMonthsIsValidData}
 required={true}
 value={editLengthLengthInMonthsValueData}
 onChange={editLengthLengthInMonthsChangeData}
 onSubmit={editLengthLengthInMonthsSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Length in months"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="number"
 min={0}
 max={1200}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}